import type { ReactNode } from 'react';
import Link from '@/lib/nav/link';
import { useUser } from '@/lib/auth/client-auth';

/**
 * Landing-page CTA that routes signed-out users to the full `/signup`
 * page (matching the `/login` split-layout pattern) and signed-in
 * users straight to their workspace. Despite the name — kept for
 * historical reasons — this does NOT open a Clerk modal anymore. Ryan
 * preferred the dedicated auth page over a popover.
 */
export function SignupModalButton({
  children,
  className,
  ariaLabel,
  signedInHref = '/new-trip',
}: {
  children: ReactNode;
  className: string;
  ariaLabel?: string;
  signedInHref?: string;
}) {
  const { isLoaded, isSignedIn } = useUser();
  const signupHref = `/signup?next=${encodeURIComponent(signedInHref)}`;

  if (isLoaded && isSignedIn) {
    return (
      <Link href={signedInHref} className={className} aria-label={ariaLabel}>
        {children}
      </Link>
    );
  }

  return (
    <Link href={signupHref} className={className} aria-label={ariaLabel}>
      {children}
    </Link>
  );
}
